import { plural, t } from '@lingui/core/macro';
import type { CampaignGetFromCodeRecord } from '@navio/nsdk';
import type { CampaignClaimDeadline } from 'noddi-web';
import { buildCampaignClaimDeadline as buildClaimDeadlineLabel, mapCouponTemplatesToClaimDiscounts } from 'noddi-web';

const buildCouponValidityHint = (expiryDaysAfterReceiving: number | null | undefined): string | undefined => {
  if (expiryDaysAfterReceiving == null) {
    return undefined;
  }
  return plural(expiryDaysAfterReceiving, {
    one: `Valid for # day after you claim`,
    other: `Valid for # days after you claim`
  });
};

export const buildCampaignClaimDeadline = (expiresAt: string | null | undefined): CampaignClaimDeadline | null =>
  buildClaimDeadlineLabel(expiresAt, ({ isExpired, formattedDate }) =>
    isExpired ? t`This campaign expired on ${formattedDate}` : t`This campaign is available until ${formattedDate}`
  );

export const buildCampaignCustomerDiscounts = (campaign: CampaignGetFromCodeRecord) =>
  mapCouponTemplatesToClaimDiscounts(campaign.couponTemplates, buildCouponValidityHint);
